module.exports = __webpack_public_path__ + "static/media/Strength Of Materials.6e2948ee.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/CE/Strength Of Materials.pdf
// module id = 96
// module chunks = 0